import { Menu } from "antd";
import { PATHS, USER_ADMIN } from "commons/constants";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "store";

type Mode = "horizontal" | "inline" | "vertical";

interface NavLinkProps {
	mode?: Mode;
	setIsVisible: (boolean: boolean) => void;
}

export const NavLink = (props: NavLinkProps): JSX.Element => {
	const user = useAppSelector((state) => state.user);

	const { mode = "horizontal", setIsVisible } = props;

	const location = useLocation();

	const { pathname } = location;

	const newPath = useMemo(() => {
		if (USER_ADMIN.includes(user?.id as string)) return PATHS;

		return [PATHS[1]];
	}, [user]);

	const items = useMemo(() => {
		const URL = newPath.map((item, index) => ({
			key: index,
			label: (
				<Link onClick={() => setIsVisible(false)} to={item.path}>
					{item.name}
				</Link>
			),
		}));
		return [...URL];
	}, [newPath, setIsVisible]);

	const defaultSelectedKeys = useMemo(() => newPath.findIndex((item) => pathname.indexOf(item.path) !== -1).toString(), [newPath, pathname]);
	return (
		<div style={{}}>
			<Menu style={{ border: 0 }} theme="light" mode={mode} defaultSelectedKeys={[defaultSelectedKeys]} selectedKeys={[defaultSelectedKeys]} items={items} />
		</div>
	);
};
